import React from 'react';
import { ScrollWrapper, Table } from '../components/Table';
import { Row } from 'features/monitoring/percents/Row';
import { parallels, PercentsRowProps, TotalPercentsRowProps } from 'features/monitoring/models';

interface Props {
  rows: PercentsRowProps[];
  total: TotalPercentsRowProps;
  showSchools: boolean;
}

const Component = ({ rows, total, showSchools }: Props) => {
  return (
    <ScrollWrapper>
      <Table>
        <thead>
          <tr>
            <th rowSpan={2} style={{ paddingLeft: '16px', width: '195px', textAlign: 'start' }}>
              {showSchools ? 'Населённый пункт' : 'Муниципалитет'}
            </th>
            {showSchools && (
              <th rowSpan={2} style={{ paddingLeft: '16px', width: '161px', textAlign: 'start' }}>
                Школа
              </th>
            )}
            <th colSpan={2} style={{ width: '157px' }}>
              Ученики
            </th>
            <th colSpan={8} style={{ width: '286px' }}>
              Процент выполнения в параллелях
            </th>
            <th rowSpan={2} style={{ width: '83px' }}>
              Средн. % выполн.
            </th>
          </tr>
          <tr>
            <th>
              Зарег. на
              <br /> Учи.ру
            </th>
            <th>
              Участв.
              <br />в тесте
            </th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <Row {...row} showSchool={showSchools} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={showSchools ? 2 : 1} style={{ paddingLeft: '16px', textAlign: 'start' }}>
              Итого по {showSchools ? 'муниципалитету' : 'региону'}:
            </td>
            <td>{total.registeredStudentsCount}</td>
            <td>{total.testedStudentsCount}</td>
            {parallels.map((parallel) => (
              <td>{total.percentsByParallels[parallel] || 0}</td>
            ))}
            <td>{total.averagePercent}</td>
          </tr>
        </tfoot>
      </Table>
    </ScrollWrapper>
  );
};

export default Component;
